var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBucket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-bucket-1{fill:#aecbfa;}.cls-bucket-2{fill:#669df6;}.cls-bucket-3{fill:#4285f4;}.cls-bucket-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_CloudStorage_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-1",
    x: 2,
    y: 4,
    width: 20,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-2",
    x: 20,
    y: 4,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bucket-3",
    points: "22 4 20 4 20 11 22 4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-2",
    x: 2,
    y: 4,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-4",
    x: 6,
    y: 7,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-4",
    x: 15,
    y: 6,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-1",
    x: 2,
    y: 13,
    width: 20,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-2",
    x: 20,
    y: 13,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bucket-3",
    points: "22 13 20 13 20 20 22 13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-2",
    x: 2,
    y: 13,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-4",
    x: 6,
    y: 16,
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bucket-4",
    x: 15,
    y: 15,
    width: 3,
    height: 3,
    rx: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBucket);
export default __webpack_public_path__ + "static/media/bucket.ff8b1f8ddd424f66f9991e94b9c5543f.svg";
export { ForwardRef as ReactComponent };